module.exports = __webpack_public_path__ + "img/logo.cfe56243.png";